import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL
  // 'http://localhost:5240/api', // o tu base URL
  //baseURL: 'https://qaazr-dev-api-hubpedidos.qualtia.com/v1/api', // o tu base URL
  //baseURL: 'https://qaazr-qa-api-hubpedidos.azurewebsites.net/v1/api', // o tu base URL
});

// Añadir interceptor para incluir token en cada petición
apiClient.interceptors.request.use(config => {
  const token = localStorage.getItem('token'); // o de donde tengas el token
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default apiClient; 
